import axios from "axios";

const config = require("../config.json");

const SP_API = function (options, cached=false) {
  // Compose the URL
  if (!options.url) {
    options.url = config.INDIANFREIGHTINDEX_API;
  }

  if (localStorage.getItem("token")) {
    if (!options.headers) {
      options.headers = {};
    }
    options.headers['Authorization'] = "Bearer " + localStorage.getItem("token");
  }

  // Set timeout to 30s unless specified otherwise.
  if (!options.timeout) {
      options.timeout = 30000;
  }

// On Success, return the response payload.
    const onSuccess = function (response) {
    if (response.data) {
      return response.data;
    }
    };
    // On Error, console log. TODO: Exception handle this.
    const onError = function (error) {
    console.error("Request Failed:", error.config);

    if (error.response) {
      // Request was made but server responded with something
      // other than 2xx
      console.error("Status:", error.response.status);
      console.error("Data:", error.response.data);
      console.error("Headers:", error.response.headers);
    } else {
      // Something else happened while setting up the request
      // triggered the error
      console.error("Error Message:", error.message);
    }
    // Reject the promise
    return Promise.reject(error.response || error.message);
    };

  if (cached) {
    // TODO
    console.log("Cached");
    //    return cached_api(options).then(onSuccess).catch(onError);
      return axios(options).then(onSuccess).catch(onError);
  } else {
    return axios(options).then(onSuccess).catch(onError);
  }
};

export default SP_API;
